export default __webpack_public_path__ + "static/media/roadmap-ellipse-left.aaaadddd.svg";